/** Premier élément VISIBLE portant `data-help=<key>` (un double masqué —
 *  hamburger mobile vs barre de bureau — ne compte pas). */
export function findTarget(key: string): HTMLElement | null {
  // Les clés sont `domaine.sujet` ; l'échappement couvre le reste (et jsdom,
  // qui n'expose pas `CSS.escape`).
  const safe = key.replace(/["\\]/g, "\\$&");
  const all = document.querySelectorAll<HTMLElement>(`[data-help="${safe}"]`);
  for (const el of all) {
    const r = el.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) return el;
  }
  return null;
}
